<template>
    <CodiceFeanorView tool-module="ecdh" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
